import { vservice } from '@niknevis/vue-modules'
import AuthRoute from '@/modules/user/routes/auth.route'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import {
  UserLoginRequestModel,
  UserPasswordResetRequestModel,
  UserPasswordResetUpdateModel,
  UserPhoneVerifyRequestModel,
  UserRegisterRequestModel,
  UserSendPhoneVerificationRequestModel
} from '@/modules/user/models/user-request.model'


@vservice()
export class AuthService {
  constructor(
    private readonly routes: AuthRoute
  ) {
  }

  login(data: UserLoginRequestModel) {
    return Inertia.post(
      this.routes.login(),
      data
    )
  }

  register(data: UserRegisterRequestModel) {
    return Inertia.post(
      this.routes.register(),
      data
    )
  }

  passwordResetRequest(data: UserPasswordResetRequestModel) {
    return HTTP.post(
      this.routes.passwordResetRequest(),
      data
    ).then(result => result.json())
  }

  passwordResetUpdate(data: UserPasswordResetUpdateModel) {
    return Inertia.post(
      this.routes.passwordResetUpdate(),
      data
    )
  }

  resendEmailVerification() {
    return Inertia.post(
      this.routes.resendEmailVerification()
    )
  }

  resendVerificationSmsCode(data: UserSendPhoneVerificationRequestModel) {
    return HTTP.post(
      this.routes.resendVerificationSmsCode(),
      data
    ).then(result => result.json())
  }

  phoneVerify(data: UserPhoneVerifyRequestModel) {
    return Inertia.post(
      this.routes.phoneVerify(),
      data
    )
  }

  phoneVerifyPageVerification(data: UserPhoneVerifyRequestModel) {
    return Inertia.post(
      this.routes.phoneVerifyPageVerification(),
      data
    )
  }

}